import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { LANGUAGES } from "../i18n/languages";

export default function LanguageSwitcher({ className = "", dark = true }) {
  const { language, setLanguage } = useI18n();

  return (
    <div
      className={`language-switcher ${dark ? "language-switcher--dark" : "language-switcher--light"} ${className}`}
      role="group"
      aria-label={language === "es" ? "Seleccionar idioma" : "Select language"}
    >
      {LANGUAGES.map((option) => (
        <button
          key={option.code}
          type="button"
          className={`language-switcher__option ${language === option.code ? "is-active" : ""}`}
          onClick={() => setLanguage(option.code)}
          aria-label={option.label}
          aria-pressed={language === option.code}
          title={option.label}
        >
          <img src={option.flag} alt="" aria-hidden="true" />
          <span>{option.code.toUpperCase()}</span>
        </button>
      ))}
    </div>
  );
}
